import React from 'react';

function getTitleColorFromClientVars() {
    var _a, _b, _c, _d;
    const personalizeInfo = (((_b = (_a = window.basicClientVars) === null || _a === void 0 ? void 0 : _a.docInfo) === null || _b === void 0 ? void 0 : _b.personalizeInfo)
        || ((_c = window === null || window === void 0 ? void 0 : window.clientVars) === null || _c === void 0 ? void 0 : _c.personalizeInfo) // native 离线详情页场景兼容
    );
    const maybeColor = (_d = personalizeInfo === null || personalizeInfo === void 0 ? void 0 : personalizeInfo.titleColor) === null || _d === void 0 ? void 0 : _d.color;
    return maybeColor || '';
}
function MobileMenuTitlebar(props) {
    // 如果在子菜单中，直接渲染子菜单标题
    if (props.isSubMenu) {
        return (React.createElement("div", { className: "mobile-menu-panel-v2-title-bar mobile-menu-panel-v2-title-bar-submenu" },
            React.createElement("div", { className: "mobile-menu-panel-v2-title-bar-submenu-back", onClick: props.onPop }),
            React.createElement("div", { className: "mobile-menu-panel-v2-title-bar-submenu-title" }, props.title)));
    }
    if (props.label && !props.isSubMenu) {
        return (React.createElement("div", { className: "mobile-menu-panel-v2-header-title" },
            React.createElement("div", { className: "mobile-menu-panel-v2-header-title-text" }, props.label),
            React.createElement("div", { className: "mobile-menu-panel-v2-header-title-close", onClick: props.onClose })));
    }
    // 如果在主菜单中，渲染主菜单标题
    if (!props.show)
        return null;
    const { title, titleTag, tags, icon, iconClass, customElement, onClick, showCloseBtn = true, } = props;
    return (React.createElement("div", { className: "mobile-menu-panel-v2-title-bar", onClick: (e) => {
            var _a;
            try {
                onClick === null || onClick === void 0 ? void 0 : onClick(e);
            }
            finally {
                if (!e.isDefaultPrevented()) {
                    // this.panelInstance.current?.hide();
                    // this.dispatchMobileMenuStateChangeEvent(true);
                    (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props, e);
                }
            }
        } },
        // 如果 icon 是 一个 react 组件, 作为子节点进行渲染
        (icon instanceof Object)
            ? React.createElement("div", { className: "mobile-menu-panel-v2-title-bar-icon" }, icon)
            : React.createElement("div", { className: `mobile-menu-panel-v2-title-bar-icon ${iconClass !== null && iconClass !== void 0 ? iconClass : ''}`, style: icon ? { backgroundImage: `url(${icon})` } : {} }),
        React.createElement("div", { className: "mobile-menu-panel-v2-title-bar-rows" },
            React.createElement("div", { className: "mobile-menu-panel-v2-title-bar-row" },
                React.createElement("div", { className: "mobile-menu-panel-v2-title-bar-title", style: { color: getTitleColorFromClientVars() } }, title),
                React.createElement("div", { className: "mobile-menu-panel-v2-title-bar-pusher" }),
                !!customElement && React.createElement("div", { className: "mobile-menu-panel-v2-title-bar-elements" }, customElement)),
            (tags !== null && tags !== void 0 ? tags : titleTag) && (React.createElement("div", { className: "mobile-menu-panel-v2-title-bar-row" }, tags === null || tags === void 0 ? void 0 :
                tags.map((tag, i) => React.createElement("div", { className: "mobile-menu-panel-v2-title-bar-tag", key: `tag-${i}` }, tag)),
                titleTag && (React.createElement("div", { className: "mobile-menu-panel-v2-title-bar-title-tag" }, titleTag))))),
        showCloseBtn && (React.createElement("div", { className: "mobile-menu-panel-v2-title-bar-close", onClick: props.onClose }))));
}

export { MobileMenuTitlebar };
//# sourceMappingURL=mobile-menu-titlebar.js.map
